export const DAYS_OF_WEEK = [
	{ value: 'MO', label: 'Monday' },
	{ value: 'TU', label: 'Tuesday' },
	{ value: 'WE', label: 'Wednesday' },
	{ value: 'TH', label: 'Thursday' },
	{ value: 'FR', label: 'Friday' },
	{ value: 'SA', label: 'Saturday' },
	{ value: 'SU', label: 'Sunday' },
] as const
